import { Link } from "react-router-dom";

import { getGoogleClientId, getFacebookClientId } from "../../utils/general-config";
import FacebookLogin from "react-facebook-login";
import { Trans, useTranslation } from "react-i18next";
import InputText from "../../components/shared/input-text/component";
import { Helmet } from "react-helmet";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
const LegalSimpliSignIn = ({
  pwdNavigate,
  signUpNavigate,
  onSignIn,
  disableBtn,
  responseFacebook,
  googleLogin,
  passwordError,
  emailError,
  passwordErrorMsg,
  onEmailChangeHandler,
  emailId,
  onPwdChangeHandler,
  onPasswordKeyPress,
  pwd,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <meta name="description" content={t("sign_in.ls.description_meta")} />
        <title>{t("page_title.ss.sign_in")}</title>
      </Helmet>
      <section className="main-content ">
        <div className="container mx-auto ">
          <div className="form-wrap">
            <hgroup className="text-center user-page">
              <h1
                className="main-headline  text-[#424a5b] font-poppins text-3xl font-bold md:font-extrabold lg:font-extrabold mt-0 pb-2.5"
                style={{ fontFamily: '"Rubik", sans-serif' }}
              >
                {t("sign_in.ls.headline")}
              </h1>
            </hgroup>

            <div className="social-login ">
              <div className="social-login--google">
                <button type="button" id="googleBtn" className="google-login-button text-white" onClick={googleLogin}>
                  <div className="bg-white m-px rounded-sm">
                    <img src={process.env.PUBLIC_URL + "/static/images/google-normal.svg"} />
                  </div>
                  <span> {t("sign_in.signin_with_google")}</span>
                </button>
              </div>
              <div className="social-login--facebook">
                <FacebookLogin
                  appId={getFacebookClientId()}
                  fields="name,email"
                  textButton={t("sign_in.signin_with_fb")}
                  callback={responseFacebook}
                  icon={
                    <img
                      src={process.env.PUBLIC_URL + "/static/images/facebook-login.svg"}
                      className="facebook-login-button"
                      id="fbBtn"
                    />
                  }
                />
              </div>
            </div>

            <div className="or-container !my-0">
              <span></span> {t("sign_in.or")} <span></span>
            </div>
            <div className="form-container !max-w-96">
              <div className="form-text mb-2">
                {(passwordError || emailError) && (
                  <p
                    key="pswrdErr"
                    className="alert error border bg-orange-50 border-orange-500 text-[#fe8c26] px-2 py-1"
                    dangerouslySetInnerHTML={{
                      __html: passwordErrorMsg,
                    }}
                  />
                )}
              </div>

              <div className="">
                <InputText
                  showLabel={false}
                  id="email"
                  text="Email Address"
                  onChange={onEmailChangeHandler}
                  className="border-gray-300 rounded  p-2 border mb-3 "
                  value={emailId.trim()}
                  maxLength={100}
                  placeholder={t("sign_in.ls.placeholder_email")}
                />
              </div>
              <div className="">
                <InputText
                  showLabel={false}
                  id="password"
                  text="Password"
                  type="password"
                  onChange={onPwdChangeHandler}
                  value={pwd}
                  className="border-gray-300 rounded  p-2 border mb-3 "
                  onKeyPress={onPasswordKeyPress}
                  placeholder={t("sign_in.ls.placeholder_password")}
                />
              </div>
              <div className="flex flex-col items-center space-y-4">
                <div className="check_box flex justify-between items-center w-full px-1 ">
                  <label className="form-check flex items-center space-x-2 text-sm text-[#424a5c]">
                    <input className="form-check-input" type="checkbox" value="" />
                    <span className="checkmark peer-checked:bg-orange-500">{t("sign_in.ls.remember_me")}</span>
                  </label>
                  <button
                    id="ForgotPassword"
                    className="setCulture text-sm text-[#0f67cb] font-medium"
                    isLoading={false}
                    disabled={disableBtn}
                    onClick={pwdNavigate}
                  >
                    {t("sign_in.ls.forgot")}
                  </button>
                </div>
                <div className=" fbn bounce-effect fixed md:relative bottom-0 left-0 bg-white  border-gray-300 p-2 md:p-0 lg:p-0 text-center w-full md:w-auto lg:w-auto z-50">
                  <button
                    className="bg-[#f9593a] hover:bg-[#424a5b] text-white rounded font-extrabold  py-3 px-7 w-full uppercase "
                    isLoading={false}
                    disabled={false}
                    type="submit"
                    onClick={onSignIn}
                  >
                    {t("sign_in.btn_cta")}
                  </button>
                </div>

                <p className="mt-4">
                  {t("sign_in.ls.don't _have_account")}. -{" "}
                  <button
                    className="setCulture font-bold  text-[#0f67cb] hover:text-[#f9593a]"
                    isLoading={false}
                    disabled={disableBtn}
                    onClick={signUpNavigate}
                  >
                    <i>
                      <FontAwesomeIcon icon={faUser} className="text-center" />
                    </i>{" "}
                    {t("sign_in.ls.sign_up")}
                  </button>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LegalSimpliSignIn;
